import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import BuildIcon from '@mui/icons-material/Build'

function MaintenancePage() {
  return (
    <Container maxWidth='md' data-testid='maintenance-page'>
      <Stack
        sx={{
          alignItems: 'center',
          fontSize: '60px',
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center'
        }}
      >
        <BuildIcon
          sx={{ color: '#54358A', marginBottom: '10px' }}
          data-testid='maintenance-icon'
          fontSize='inherit'
        />
        <Typography variant='h3' gutterBottom>
          We are currently performing scheduled maintenance.
        </Typography>
        <Typography variant='h6'>
          We apologise for any inconvenience and appreciate your patience. Please check back soon.
        </Typography>
      </Stack>
    </Container>
  )
}

export default MaintenancePage
